import { Route } from '@angular/router';
import { AuthGuard } from '@/app/core/auth/guards/auth.guard';
import { NoAuthGuard } from '@/app/core/auth/guards/noAuth.guard';

export const routes: Route[] = [
  // Auth (only reachable when signed out)
  {
    path: 'auth',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    loadChildren: () => import('./domains/auth/routes'),
  },

  // Root → admin (guarded below)
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'admin',
  },

  // Admin (requires authentication)
  {
    path: 'admin',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./domains/admin/routes'),
  },
];
